import { Flex } from '@/components';
import { fetchGovernmentNumber } from '@/features/government-search/_utils/search-government';
import { ProjectsSearch } from '@/features/search/_components/projects/ProjectsSearch';
import type { ProjectsSearchSubmitType } from '@/features/search/_utils/projects-search';
import { isPS } from '@/utils';
import { useCallback } from 'react';
import { SegmentSwitcher } from '../../_components/SegmentSwitcher';
import { useSearchHistory } from '../../_hooks/search-projects/local-storage';
import { useProjectsPageSearchQueryStates } from '../../_hooks/search-projects/search-query-states';
import { convertInputValueToRequestParams } from '../../_utils/convert-request-params';
import { FilterResult } from '../_components/FilterResult';
import { NavigateDetailsWithOpenButton } from '../_components/NavigateDetailsWithOpenButton';
import { generateSearchHistoryLabelsMap } from '../_utils/convert-history-label';

export const ProjectsPage = () => {
  const { setSearchQueryStates } = useProjectsPageSearchQueryStates();
  const { setSearchHistoryStorage } = useSearchHistory();

  const handleSearchSubmit = useCallback(
    async ({
      values,
      newCascadeId,
      inputCascaderAndAccountingLabels,
    }: ProjectsSearchSubmitType) => {
      const corporateInfo = values.corporateNumber
        ? await fetchGovernmentNumber({
            corporateNumber: values.corporateNumber,
          })
        : undefined;
      const requestParams = convertInputValueToRequestParams(
        values,
        newCascadeId,
      );

      const removeNullValues = Object.fromEntries(
        Object.entries(requestParams).filter(
          ([_, value]) => value !== null && value !== undefined,
        ),
      );

      setSearchHistoryStorage(
        JSON.parse(JSON.stringify(removeNullValues)),
        generateSearchHistoryLabelsMap(
          requestParams,
          inputCascaderAndAccountingLabels,
          corporateInfo?.at(0)?.corporateName ?? null,
        ),
      );
      setSearchQueryStates((prev) => ({ ...prev, ...requestParams }));
    },
    [setSearchQueryStates, setSearchHistoryStorage],
  );

  return (
    <Flex vertical gap={16}>
      {!isPS() && <SegmentSwitcher segment="project" />}
      <Flex vertical gap={24}>
        <ProjectsSearch onSubmit={handleSearchSubmit} type="project" />
        <FilterResult
          isFromGroupPage={false}
          projectTableActionsColumn={{
            title: '',
            key: 'actions',
            fixed: 'right',
            width: 100,
            render: (_, record) => (
              <NavigateDetailsWithOpenButton projectId={record.id} />
            ),
          }}
        />
      </Flex>
    </Flex>
  );
};
